import { createSlice } from "@reduxjs/toolkit";
import { fetchCompanyDetails } from "./company.thunk";

const companyInitialState = {
  companyId: null,
  domainName: "",
  languageCode: "en",
  companyName: "",
  companySubscriptionValidity: "",
  defaultTimeZone: "",
  subscriptions: {
    dynamicMessageConstruction: false,
    testRuleUnderConstruction: false,
  },
};

const companySlice = createSlice({
  name: "company",
  initialState: companyInitialState,
  reducers: {
    setCompanyDetails: (state, action) => {
      return { ...state, ...action.payload };
    },
    resetCompanyDetails: () => {
      return { ...companyInitialState };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCompanyDetails.fulfilled, (state, action) => {
      const { isDynamicMessageConstruction, isTestRuleUnderConstruction } =
        action.payload;
      return {
        ...state,
        subscriptions: {
          dynamicMessageConstruction: isDynamicMessageConstruction,
          testRuleUnderConstruction: isTestRuleUnderConstruction,
        },
      };
    });
  },
});

export const { setCompanyDetails, resetCompanyDetails } = companySlice.actions;
export default companySlice.reducer;
